import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PayableReportService {

  constructor(private httpService: HttpService) { }

    getPayableReportForTable(data: any) {
        const url = `${environment.OrderApiendpoint}/payable-reports?${data}`;
        return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }
    getBatchListForTable(data: any) {
        const url = `${environment.OrderApiendpoint}/batch-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }
    createBatch(data: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/create-batch`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    deleteBatch(id: any) {
        const url = `${environment.OrderApiendpoint}/delete-batch/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    paidBatch(id: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/paid-batch/${id}`
        return this.httpService.post(url, [], this.httpService.headers)
    }
    // paidBatch(id: any) {
    //     const url = `${environment.OrderApiendpoint}/paid-batch/${id}`;
    //     return this.httpService.put(url,this.httpService.headers)
    //         .pipe(
    //             catchError(this.Errorhandling)
    //         );
    // }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {

            console.error(err.error.message);
        } else {

            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
